import OrderAddressSearchComponent from "../../components/order/OrderAddressSearchComponent.tsx";
import {imageMap} from "../../images/imageMap.ts";
import Icon from "../../components/selfcare/Icon.tsx";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import {Link} from "react-router-dom";
import QuestionAnswerComponent, {Question} from "../../components/help/QuestionAnswerComponent.tsx";
import {BigCoverMapRegions} from "../../components/coverageMap/CoverageMap.ts";
import CoverageMapContainer from "../../components/coverageMap/CoverageMapContainer.tsx";
import useDatalayer from "../../components/useDatalayer.tsx";
import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";
import Routing from "../../Routing.ts";
import IconCheck from "../../components/icons/IconCheck.tsx";

const preDefault = "fra"
const defaultPrice = 299
const time = '6 mdr.'
const campaignPrice = 99
const min6 = (6 * campaignPrice)

const questions: Question[] = [
    {
        question: 'Hvad står coax internet for?',
        answer: <p>
            Coax bliver brugt som en betegnelse for internet via kabel-tv-stik, da denne bredbåndsforbindelse anvender koaksialkabler.
            Coax er derfor en forkortelse for koaksial kabel.
        </p>,
    },
    {
        question: 'Hvad er forskellen på internet via kabel-tv-stik og fibernet?',
        answer: <>
            <p>
                Internet via dit kabel-tv-stik leveres via kobber kabler, også kaldet coax kabler &ndash; som elektriske signaler. <Link to={Routing.Broadband.Fiber}>Fibernet</Link> leveres via lyslederkabler lavet af optisk glasfiber, som overfører data lynhurtigt.
                Der er derfor tale om to forskellige teknologier i leveringen af internettet.
                Fibernet har højere uploadhastighed og lavere ping end coax internet og er derfor en tand hurtigere.
            </p>
            <p>
                Læs mere om forskellene mellem de <Link to="/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge">forskellige internetforbindelser her</Link>.
            </p>
        </>,
    },
    {
        question: 'Skal jeg selv opsige min nuværende bredbåndsaftale hos en anden udbyder?',
        answer: <>
            <p>
                Vi kan opsige dit nuværende abonnement for dig.
                Når du bestiller hos os, kan du udfylde en fuldmagt digitalt, der giver os lov til at opsige abonnementet for dig.
            </p>
            <p>
                Hvis du ikke udfylder fuldmagten i forbindelse med bestillingen, får du også en mail med mere information.
            </p>
        </>,
    },
    {
        question: 'Hvor lang er min bindingsperiode?',
        answer: <p>
            Der er 6 måneders binding på dit Hiper bredbånd, som gælder fra leveringsdatoen.
            Hvis du vælger at opsige dit abonnement, får du en bekræftelse i en mail, hvor du kan se den præcise slutdato for abonnementet, og hvordan du skal returnere det fremsendte udstyr.
        </p>,
    },
    {
        question: 'Skal jeg have en tekniker på besøg?',
        answer: <p>
            Hvis du bestiller 1000 Mbit, skal kabel-tv-stikket i din bolig være opdateret til DOCSIS 3.1.
            Hvis stikket ikke er opdateret, kan du gratis få en tekniker på besøg, der kan opdatere det. <button
                className={'link'}
                onClick={() => DispatchHighLightAddressSearchEvent(true)}
            >Tjek din adresse</button> og se om du kan få 1000 Mbit coax internet.
        </p>,
    },
    {
        question: 'Kan jeg bruge mit eget udstyr?',
        answer: <>
            <p>
                Ja, du er altid velkommen til at bruge dit eget udstyr.
            </p>
            <p>
                <Link to="/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr">Læs mere her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg få en fast IP-adresse?',
        answer: <>
            <p>
                Det er kun muligt at tilbyde en gratis dynamisk IP-adresse på kabel-tv-stik, og ikke en fast IP.
            </p>
            <p>
                <Link to="/hjaelp/internet-og-wifi/ip-adresse">Læs mere her</Link>.
            </p>
        </>,
    },
    {
        question: 'Kan jeg få tv-pakker hos Hiper?',
        answer: <p>
            Nej, vi sælger kun internet.
            Det betyder, at vi ikke har TV-pakker eller andre streamingtjenester inkluderet i vores bredbåndsløsninger.
            Med det sagt, så kan du godt bruge vores lynhurtige internet til streaming på alle streamingtjenester, hvor du skulle have et abonnement.
        </p>,
    },
    {
        question: 'Har I mobilabonnementer eller mobilt bredbånd?',
        answer: <p>
            Vi har mobilt bredbånd, men vi sælger ikke <a href="https://www.telmore.dk/mobilabonnement" target="_blank">mobilabonnementer</a>.
            Hvis du køber 5G-internet hos Hiper, får du Danmarks bedste 5G-dækning.
            Læs mere om <Link to={Routing.Broadband.TDC5G}>vores 5G-internet her</Link>.
        </p>,
    },
]

export default function CoaxPage() {
    ScrollToTop()
    useDatalayer()
    setTitleAndMetaDescription('Bredbånd via kabel-tv-stik | Lynhurtigt og stabilt coax internet', 'Køb internet via kabel-tv-stikket, også kaldet coax internet til en knivskarp pris. Få 100 eller 1000 Mbit bredbåndbånd via antennestik i dag.')

    return (
        <div className={"page-products-coax"}>
            <div id="hero-container" className="hero-container hero-container--products hero-container--products-coax">
                <div className="hero-background-wrapper">
                    <div className="hero-background">
                        <img
                            className="product-image"
                            src={imageMap.products.router_coax}
                            alt="Sagemcom router til dit internet via kabel-tv-stik."
                        />
                        <div className="stamp stamp--fly-in">
                            <img
                                src={imageMap.home.mvfp_2025}
                                alt="Hiper er vinder af Mest Værdi For Pengene 2025 for blandt andet vores gode coax internet."
                            />
                        </div>
                    </div>
                </div>
                <div className="hero-content">
                    <h1>
                        <span className="header-tech">Hurtigt bredbånd via <span className="no-wrap">kabel-tv-stik</span></span>
                        <span className="header-sub">Få en hastighed på op til 1000&nbsp;Mbit</span>
                    </h1>
                    <ul>
                        <li>
                            <Icon component={IconCheck}/>
                            <p>Op til 1.000 / 500 Mbit</p>
                        </li>
                        <li>
                            <Icon component={IconCheck}/>
                            <p>Stabilt netværk i hjemmet</p>
                        </li>
                        <li>
                            <Icon component={IconCheck}/>
                            <p>God løsning til familien</p>
                        </li>
                        <li>
                            <Icon component={IconCheck}/>
                            <p>Stabil streaming</p>
                        </li>
                    </ul>
                    <h2>
                        <span className="before-after">Få <strong>1000 Mbit</strong> de første {time} {preDefault} </span>
                        {campaignPrice}<span className="price-comma-dash">,-</span>
                        <span className="before-after"> /md.</span>
                    </h2>
                </div>
                <div className="address-wrap">
                    <h2>
                        Tjek hvor hurtigt coax internet du kan få
                        <div className="scroll-down-arrow"></div>
                    </h2>
                    <OrderAddressSearchComponent/>
                </div>
                <p className="conditions">
                    Inkl. gratis oprettelse og lånerouter.
                    Min. pris i 6 mdr. fra {min6} kr.
                    Pris efter {time} {preDefault} {defaultPrice} kr./md.
                    Pris efter {time} {preDefault} {defaultPrice} kr./md.
                    Tilbuddet gælder kun internet via kabel-tv-stikket.
                    Forudsætter at du ikke har været kunde de seneste 6 mdr.
                </p>
            </div>

            <section className="section-lightgrey section-reasons">
                <div className="content content--medium">
                    <div className="blurb">
                        <h2 className="heading heading--big">3 fordele til bredbånd via kabel-tv-stik</h2>
                    </div>
                    <ul className="grid grid-triple-with-icons grid-triple-with-count">
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Nem installation</h3>
                            <p>
                                Når du modtager din router med posten, er det utroligt nemt at få din nye forbindelse op og køre.
                                Du sætter bare din router i kabel-tv-stikket og så er du i gang med dit coax internet.
                            </p>
                        </li>
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Lynhurtig streaming</h3>
                            <p>
                                Stream nemt alle dine yndlingsserier og film direkte på TV-skærmen via Chromecast, Apple TV eller Smart TV &ndash; helt uden forsinkelser.
                                Bedst af alt, så kan hele familien gøre det på samme tid fra forskellige enheder.
                            </p>
                        </li>
                        <li>
                            <h3 className="heading heading--medium heading--montserrat">Mange enheder på én gang</h3>
                            <p>
                                Der kan games og streames på børneværelserne, samtidig med at musikken spiller trådløst på højtalerne i stuen.
                                Alt på samme tid &ndash; uden noget bøvl.
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white section-includes">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Det får du med i dit coax internet abonnement</h2>
                    </div>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <img src={imageMap.products.router_coax2} alt="Sagemcom router så du kan få dit COAX internet til at spille."/>
                        </li>
                        <li>
                            <h3 className="heading heading--paragraph heading--smaller heading--left"><strong>
                                En af markedets bedste coax routere
                            </strong></h3>
                            <p>
                                Bestiller du bredbånd via kabel-tv-stik hos os får du en af markedets bedste Sagemcom routere med hurtig wifi 4x4 802.11ac-teknologi.
                                Coax-routeren understøtter både <Link
                                to="/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser"
                            >2,4 og 5 GHz</Link>, og du vælger selv om du vil benytte wifi i din bolig eller om du ønsker en kablet LAN-forbindelse.
                            </p>
                            <p>
                                <Link to="/hjaelp/udstyr/hvilken-router-foelger-med">Læs mere om routeren</Link>
                            </p>
                        </li>
                    </ul>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <img
                                src={imageMap.products.mit_hiper}
                                alt="Med bredbånd via kabel-tv-stik får du adgang til Mit Hiper selvbetjening."
                            />
                        </li>
                        <li>
                            <h3 className="heading heading--paragraph heading--smaller heading--left"><strong>
                                Adgang til egen selvbetjening
                            </strong></h3>
                            <p>
                                Når du bestiller et internetabonnement hos Hiper, så får du adgang til din egen selvbetjening, Mit Hiper, hvor du kan finde dine regninger, skifte betalingskort m.m..
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big heading">Internet via kabel-tv-stik</h2>
                    </div>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <p>
                                Bredbånd via kabel-tv-stik benytter coaxial-kabler, som er en skærmet kabelteknologi, der understøtter meget store informationsmængder og hastigheder op til tusind Mbit.
                                Bredbåndsforbindelsen leveres over det eksisterende kabel-tv-stik, så du nemt kan tilslutte din router og komme på nettet.
                                Bredbåndsforbindelsen og tv-kanaler sendes over coax internettet på forskellige frekvenser, og de forstyrrer derfor ikke hinanden.
                            </p>
                            <p>
                                Langt de fleste husstande med antennestik kan få bredbånd via kabel-tv-stik.
                                Der er dog stadig nogle steder, hvor du er nødt til at have en tv-pakke for at få Hiper bredbånd via kabel-tv-stik.
                                Det kan skyldes lokale tekniske forhold eller at din bolig- eller antenneforening ikke giver mulighed for bredbånd uden tv endnu.
                                Hiper tilbyder dog ingen tv-pakker, blot faste installationer på internet.
                            </p>
                            <p>
                                <button
                                    className={'link'}
                                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                >Tjek din adresse</button> for at se om du kan få bredbånd via kabel-tv-stik.
                            </p>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="section-white">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Værd at vide inden du bestiller internet via <span className="no-wrap">kabel-tv-stik</span>
                        </h2>
                    </div>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </section>

            <section className="section-white section-coverage">
                <div className="content content--narrow">
                    <div className="blurb">
                        <h2 className="heading heading--big">Se om vi dækker internet via kabel-tv-stik i dit område</h2>
                    </div>
                    <ul className="grid grid-triple no-boxes">
                        <li>
                            <p>
                                Vores bredbånd via antennestik er ideelt for både små og store husstande.
                                Uanset om du har brug for kabel-tv-internet til arbejde, underholdning eller begge dele, har vi en løsning, der passer til dig.
                                Fra streaming af dine yndlingsserier til download af store filer &ndash; kan vores coax internet levere på alle fronter.
                            </p>
                            <p>
                                Se hvor vi leverer bredbånd via kabel-tv-stik på TDC Nets netværk til en super skarp pris. <button
                                    className={'link'}
                                    onClick={() => DispatchHighLightAddressSearchEvent(true)}
                                >Indtast din adresse</button> i søgefeltet og se om du kan få coax internet hos os.
                            </p>
                            <p>
                                Områderne vi dækker, er markeret med blåt på kortet.
                            </p>
                        </li>
                        <li>
                            <CoverageMapContainer
                                regionPreset={BigCoverMapRegions.COAX}
                                fiberMapOnly={false}
                                static={true}
                            />
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    )
}
